import React, { useState } from 'react'
import './Style/SideBar.css'
import Logo from './Assets/logo.png'
import  {SidebarData} from './Data/Data'
import {UilSignOutAlt} from '@iconscout/react-unicons'

const SideBar = () => {
const [selected,setSelected] = useState(0)

    
  return (
    <div className='SideBar'>
            <div className="logo">
                <img src={Logo} alt="" />
            </div>
            <div className="menu">
               {SidebarData.map((item,index)=>{
                    return(
                        <div className={selected===index?'menuitem active':'menuitem' }
                        key={index}
                        onClick={()=>setSelected(index)}
                        >
                            <item.icon/>
                            <span>
                                {item.heading}
                            </span>
                        </div>
                    )
               })}
                <div className="menuitem">
                    <UilSignOutAlt/>
                </div>
                
            </div>
    </div>
  )
}

export default SideBar   